import { Filter } from 'app/modules/filters/models';
import { u21CreateSlice } from 'app/shared/thunk/u21CreateSlice';
import { PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  filters: [] as Filter[],
};

const slice = u21CreateSlice({
  initialState,
  name: 'workflowVisualizerSlice',
  reducers: {
    setFilters: (draft, action: PayloadAction<Filter[]>) => {
      draft.filters = action.payload;
    },
  },
});

export const NAME = slice.name;
export const { setFilters } = slice.actions;
export default slice.reducer;
